<app-header-content-footer *transloco="let t"
  [headerTitle]="t('point-balance-list')">
  <app-sidenav-content content showBanner>
    <app-point-balance-list content [business]="business" [isMobile]="isMobile"></app-point-balance-list>
  </app-sidenav-content>
</app-header-content-footer> 
